import axios from '@/helpers/axios';
import { IGetEligibleLineCountRequest } from '@/reducers/order/models/orderModel';
import { adminApi, custServiceApi, inventoryApi, orderApi, shoppingApi, catalogueApi, refitLineApi } from '@/helpers/apis';
import {
  TERMINATE_NUMBER,
  CHANGE_PLAN,
  CEASE_ADDONS,
  BUY_ADD_ONS,
  NUMBER_SHARE,
  CHANGE_MOBILE_NUMBER,
  SUSPEND_LINE,
  UNSUSPEND_LINE
} from '@/config/common';

export const requestSaveToCart = (
  requestData,
  recalculateOnly,
  checkout,
  simOnlyValue,
  isSerFlow = false,
  isHybridSerFlow = false
) => {
  const url = `${shoppingApi.REQUEST_SAVE_TO_CART}/`;
  return axios.post(url, {
    ...requestData,
    recalculateOnly,
    checkout,
    simOnly: simOnlyValue,
    serFlow: isSerFlow,
    hybridSerFlow: isHybridSerFlow
  });
};

export const requestCartDetails = (cartId) => {
  const url = `${shoppingApi.GET_CART_DETAIL}/${cartId}`;
  return axios.get(url);
};

export const submitOrder = (reqPayload) => {
  const orderSummissionTypes = [TERMINATE_NUMBER, CHANGE_PLAN, CEASE_ADDONS, BUY_ADD_ONS, NUMBER_SHARE, CHANGE_MOBILE_NUMBER, SUSPEND_LINE, UNSUSPEND_LINE]; 
  if(reqPayload.transactionType=='EARLY_RECONTRACT'){
    reqPayload={
      ...reqPayload,
      transactionType: "RECONTRACT"
    }
  }
  let url = orderApi.POST_ORDER;
  if (orderSummissionTypes.includes(reqPayload.transactionType)) {
    url = orderApi.POST_ORDER_SUBMISSION;
  }
  return axios.post(url, reqPayload);
};

export const requestPaymentDetails = (merchantRef) => {
  const url = `${orderApi.GET_ORDER_BY_MERCHANT}/${merchantRef}`;
  return axios.get(url);
};

export const getEligibleLineCount = (reqPayload: IGetEligibleLineCountRequest) => {
  const url = adminApi.GET_ELIGIBLE_LINE_COUNT;
  return axios.post(url, reqPayload);
};

export const requestCardProfile = (payLoad) => {
  const url = inventoryApi.DIST_CARD_PROFILE;
  return axios.post(url, payLoad);
};
export const getSimCharge = (payLoad, msaHeaderId) => {
  const url = `${inventoryApi.GET_SIM_CHARGE}/${msaHeaderId}`;
  return axios.post(url, payLoad);
};

export const getPdpaOrder = (orderId) => {
  const payload = {
    orderId: orderId,
    isPDPACMOFlow: true
  };
  const url = `${orderApi.GET_ORDERINFO_PDPA}`;
  return axios.post(url, payload);
};

export const getFetchAllProducts = (reqPayload: any) => {
  const url = custServiceApi.FETCH_ALL_PRODUCTS;
  return axios.post(url, reqPayload);
};

export const checkParentSvcNumber = (reqPayload) => {
  const url = custServiceApi.CHECK_FOR_PARENT_SERVICE_NUMBER;
  return axios.post(url, reqPayload);
};

export const updateWaiverRequestStatus = (reqPayload: any) => {
  const url = orderApi.UPDATE_WAIVER_REQUEST_STATUS;
  return axios.post(url, reqPayload);
};

export const getWaiveredOrder = (link: string) => {
  const url = orderApi.GET_WAIVERED_ORDER;
  return axios.post(url, { encLink: link });
};

export const saveSmartTemplate = (payload) => {
  const url = `${catalogueApi.SAVE_SMART_TEMPLATE}`;
  return axios.post(url, payload);
};

export const requestTemplateDetails = (templateId) => {
  const url = `${catalogueApi.GET_CART_FROM_TEMPLATE}/${templateId}`;
  return axios.get(url);
};


export const refitLineSubmit = (payload) => {
  const url = refitLineApi.REFIT_ORDER_SUBMISSION;
  return axios.post(url, payload);
};

export const ordereSimQrPdpa = (payload) => {
  const url = orderApi.PDPA_ESIM_QR_RETRIEVAL;
  return axios.post(url, payload);
}

export const getBulkOrderDetailsByItemId = (payload) => {
  const url = orderApi.GET_BULK_ORDER_DETAILS_BY_ITEM_ID;
  return axios.post(url, payload);
};